import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { allCommonImages } from "../Assets/Images/images";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { svg } from "../Assets/svg";
import { alias, BUCKET_URL } from "../helpers/utils";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Close from "../Assets/Images/Icons/Close.svg";
import { UserI } from "../Admin/Types/state/user.state";
import { Swiper as SwiperClass } from "swiper";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { NavLink } from "react-router-dom";
const Logo = allCommonImages.LogoWhite;
// Site Loader
interface SiteLoaderProps {
	text?: string;
}
export const SiteLoader: React.FC<SiteLoaderProps> = ({ text }) => {
	const { pathname } = useLocation();

	if (pathname === "/") {
		return null;
	}

	return (
		<div
			style={{
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				textAlign: "center",
				width: "calc(100% - 1rem)",
			}}
		>
			<div className="Loader">
				<div className="d-block">
					<div className="spinner-border" role="status"></div>
				</div>
			</div>
			<p className="ff" style={{ fontSize: "1rem", lineHeight: "1.1" }}>
				{text !== undefined ? text : "Please wait a moment while we arrange some things"}
			</p>
		</div>
	);
};

export const BtnLoader: React.FC = () => {
	return (
		<Spin
			indicator={
				<LoadingOutlined
					style={{
						fontSize: 16,
						color: "#fff",
					}}
					spin
					className="me-2"
				/>
			}
		/>
	);
};

interface NavigationBarProps {
	menuOpen: boolean;
	setMenuOpen: (value: boolean) => void;
	navigationData: any;
}

export const NavigationBar: React.FC<NavigationBarProps> = ({ navigationData, menuOpen, setMenuOpen }) => {
	const [toggleActive, setToggleActive] = useState(true);
	const [accountClass, setAccountClass] = useState(true);
	const [isNavbarOpen, setIsNavbarOpen] = useState(false);

	const dropDownRef = useRef<HTMLDivElement>(null); // Correct reference
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	const handleClickOutside = (e: MouseEvent) => {
		// Use the correct variable name
		if (dropDownRef.current && !dropDownRef.current.contains(e.target as Node)) {
			setAccountClass(true);
		}
	};

	const toggleNavbar = () => {
		setIsNavbarOpen(!isNavbarOpen);
		setMenuOpen(!menuOpen);
	};

	return (
		<div className="device-header position-fixed w-100 top-0 px-3 py-2 d-lg-none">
			<div className="d-flex align-items-center justify-content-between h-100">
				<a className="d-inline-block" onClick={() => navigate("/admin/dashboard")}>
					<img
						src={Logo} // Replace with actual logo path
						width={169}
						height={99}
						className="img-fluid mb-navbar-logo object-fit-contain"
						alt="Logo"
					/>
				</a>
				<div className={`menu-animate-btn position-relative ${menuOpen ? "menu-open" : ""}`} onClick={toggleNavbar}>
					<span className="d-block position-absolute top-50 start-0 translate-middle-y"></span>
				</div>
			</div>
		</div>
	);
};

export const TableLoader = () => {
	return (
		<div className="loader-container py-5">
			<div className="loader">
				<div className="spinner-border" role="status"></div>
			</div>
		</div>
	);
};

export function prefixZero(e: number) {
	return Number(e) < 10 ? `${e}` : String(e);
}
interface CustomPaginationProps {
	pageId: number;
	countCalculation: number;
	setPageId: (page: number) => void;
	className: string;
	pageCount: number;
	listCount: number;
	limit: number;
	deletedData?: () => any;
}
export const CustomPagination: React.FC<CustomPaginationProps> = ({ pageId, countCalculation, setPageId, className, pageCount, listCount, limit, deletedData }) => {
	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, [pageId]);

	// Handler
	const nextPageHandler = () => {
		if (countCalculation > pageId) setPageId(pageId + 1);
	};

	const prevPageHandler = () => {
		if (pageId > 0) setPageId(pageId - 1);
	};
	const generatePageNumbers = () => {
		const pages = [];
		const startPage = Math.max(pageId - 2, 1);
		const endPage = Math.min(pageId + 2, Math.ceil(pageCount / limit));

		for (let i = startPage; i <= endPage; i++) {
			pages.push(i);
		}
		return pages;
	};

	const pageNumbers = generatePageNumbers();

	return (
		<div className={`${className} d-flex flex-wrap align-items-center justify-content-between pagination__container`}>
			<div className="">{`${pageId * limit - limit + 1} - ${limit * pageId > countCalculation ? countCalculation : limit * pageId}  out of ${countCalculation}`}</div>
			{deletedData && deletedData()}
			<nav>
				<ul className="pagination mb-0 gap-2">
					<li className={`page-item ${pageId === 1 ? "disabled" : ""}`}>
						<button className="page-link" onClick={prevPageHandler} disabled={pageId === 1}>
							{svg.pagePreview}
						</button>
					</li>
					{pageNumbers.map((page) => (
						<li className="page-item">
							{/* <button className="page-link">{prefixZero(pageId)}</button> */}
							<a className={pageId === page ? "page-link active" : "page-link"} onClick={() => setPageId(page)}>
								{prefixZero(page)}
							</a>
						</li>
					))}
					<li className={`page-item ${pageId === pageCount || limit * pageId >= countCalculation ? "disabled" : ""}`}>
						<button className="page-link" onClick={nextPageHandler} disabled={limit * pageId >= countCalculation}>
							{svg.pageNext}
						</button>
					</li>
				</ul>
			</nav>
		</div>
	);
};
export const redirectPath = {
	home: alias?.length ? alias : "/",
	aboutUs: alias?.length ? alias + "/about-us" : "/about-us",
	contactUs: alias?.length ? alias + "/contact-us" : "/contact-us",
	terms: alias?.length ? alias + "/terms-and-conditions" : "/terms-and-conditions",
	privacy: alias?.length ? alias + "/privacy-policy" : "/privacy-policy",
};

export const staticPgLogo = () => {
	return (
		<div className="text-center page-header">
			<a href={redirectPath?.home} className="d-inline-block">
				<img src={Logo} width={158} height={160} className="object-fit-contain headerLogo img-fluid" alt="Logo" />
			</a>
		</div>
	);
};

// Close Icon Image
export const CloseIcon = () => <img src={Close} alt="close" />;

type Image = {
	_id: string;
	image: string;
	thumb: string;
	user: string;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	is_active: number;
};

type Props = {
	images: Image[];
	defaultImageId: string; // Default image ID for when no images are provided
};

export const ImageGallery: React.FC<Props> = ({ images, defaultImageId }) => {
	const [thumbsSwiper, setThumbsSwiper] = useState<any | null>(null);
	const [selectedImageState, setSelectedImageState] = useState<Image | null>(null);

	// Set the default image based on defaultImageId or use the first image
	const defaultImage = images?.length > 0 ? images.find((image) => image._id === defaultImageId) || images[0] : null;
	// Set the default selected image state
	if (!selectedImageState && defaultImage) {
		setSelectedImageState(defaultImage);
	}

	// Handle Thumbnail Click
	const handleThumbnailClick = (image: Image) => {
		setSelectedImageState(image);
	};
	const selectedIndex = images?.findIndex((image) => image._id === selectedImageState?._id) + 1 || 0;
	return (
		<div>
			{/* Main Swiper */}
			<Swiper loop={true} spaceBetween={0} navigation={true} thumbs={{ swiper: thumbsSwiper }} modules={[FreeMode, Navigation, Thumbs]} className="mySwiper2 mb-3">
				{selectedImageState ? (
					[selectedImageState].map((image) => (
						<SwiperSlide key={image._id}>
							<div className="mainSliderBox position-relative overflow-hidden rounded-3">
								<img src={`${BUCKET_URL}${image?.image}`} alt="Main Image" className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover" />
							</div>
						</SwiperSlide>
					))
				) : (
					<SwiperSlide key={"noImageFound"}>
						<div className="mainSliderBox position-relative overflow-hidden rounded-3">
							<img src={`${BUCKET_URL}${"public/common/profile.svg"}`} alt="Main Image" className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover" />
						</div>
					</SwiperSlide>
				)}
			</Swiper>

			{/* Thumbnail Swiper */}
			<Swiper
				onSwiper={setThumbsSwiper}
				loop={false}
				spaceBetween={7}
				slidesPerView={4}
				freeMode={true}
				watchSlidesProgress={true}
				modules={[FreeMode, Navigation, Thumbs]}
				scrollbar={{
					draggable: true, // Enable draggable scrollbar
					hide: false, // Ensure scrollbar is visible
				}}
				style={{
					overflowX: "auto", // Allow horizontal scrolling
				}}
				className="mySwiper"
			>
				{images?.length > 0 &&
					images.map((image) => (
						<SwiperSlide key={image._id} onClick={() => handleThumbnailClick(image)}>
							<img
								src={`${BUCKET_URL}${image.thumb}`}
								alt="Thumbnail"
								style={{
									width: "75px",
									height: "90px",
									objectFit: "cover",
									borderRadius: "4px",
									border: image._id === selectedImageState?._id ? "2px solid #000" : "none", // Highlight selected thumbnail
								}}
							/>
						</SwiperSlide>
					))}
			</Swiper>
			<div style={{ textAlign: "center", marginBottom: "10px" }}>
				{images?.length > 0 && (
					<div>
						Photos {selectedIndex}/{images.length}
					</div>
				)}
			</div>
		</div>
	);
};

interface DashboardFieldIF {
	columnClass: string;
	className: string;
	path: string;
	svg: ReactNode;
	label: string;
	value?: number | string;
	color?: string;
}
export const DashboardField: React.FC<DashboardFieldIF> = ({ columnClass, className, path, svg, label, value, color }) => {
	return (
		<>
			<div className={`col-xl col-md-4 ${columnClass}`}>
				<NavLink className="card dash__card border-0 rounded-3 shadow h-100" to={path}>
					<div className="card-body d-flex flex-column justify-content-between">
						<div className={"d-flex align-items-center mb-2 " + className}>
							{svg}
							<span className={"fs-6 fw-semibold " + className} style={{ color: color ?? "black" }}>
								{label}
							</span>
						</div>
						<h3 className="fw-bolder fs-36 text-black mb-0">{value ?? 0}</h3>
					</div>
				</NavLink>
			</div>
		</>
	);
};
